export const SCHRODINGER_DURATION_FLOOR = 1;
export const SCHRODINGER_DURATION_CEILING = 300;
export const SCHRODINGER_DURATION_MIN_DEFAULT = 3;
export const SCHRODINGER_DURATION_MAX_DEFAULT = 60;
/** First holder (第一棒). Each pass adds SCHRODINGER_OBSERVE_STEP_PERCENT, capped. */
export const SCHRODINGER_OBSERVE_BASE_PERCENT = 20;
export const SCHRODINGER_OBSERVE_STEP_PERCENT = 5;
export const SCHRODINGER_OBSERVE_MAX_PERCENT = 75;
export function clampSchrodingerDurationRange(minInput, maxInput) {
    const floor = SCHRODINGER_DURATION_FLOOR;
    const ceiling = SCHRODINGER_DURATION_CEILING;
    let minSeconds = Number.isFinite(minInput) ? Math.round(minInput) : SCHRODINGER_DURATION_MIN_DEFAULT;
    let maxSeconds = Number.isFinite(maxInput) ? Math.round(maxInput) : SCHRODINGER_DURATION_MAX_DEFAULT;
    minSeconds = Math.min(ceiling, Math.max(floor, minSeconds));
    maxSeconds = Math.min(ceiling, Math.max(floor, maxSeconds));
    if (minSeconds > maxSeconds) {
        const swapped = minSeconds;
        minSeconds = maxSeconds;
        maxSeconds = swapped;
    }
    if (minSeconds === maxSeconds) {
        if (maxSeconds < ceiling) {
            maxSeconds += 1;
        }
        else {
            minSeconds -= 1;
        }
    }
    return { minSeconds, maxSeconds };
}
/** passCount 0 is the first holder. Each completed pass adds 5 points, up to 75. */
export function schrodingerObserveExplosionPercent(passCount) {
    const passes = Number.isFinite(passCount) ? Math.max(0, Math.floor(passCount)) : 0;
    return Math.min(SCHRODINGER_OBSERVE_MAX_PERCENT, SCHRODINGER_OBSERVE_BASE_PERCENT + passes * SCHRODINGER_OBSERVE_STEP_PERCENT);
}
/** Frozen reading in tenths of a second, e.g. 7.3. Does not keep ticking on the client. */
export function schrodingerRemainingSeconds(endsAt, now) {
    const remainingMs = Math.max(0, endsAt - now);
    return Math.round(remainingMs / 100) / 10;
}
//# sourceMappingURL=schrodingerCroc.js.map